import React from 'react';
import PropTypes from 'prop-types';

import { NavItem, NavItemPlaceholder } from './nav-item';

import styles from './NavList.css';

// move to utils
const arrayFill = (d) => Array(d).fill();

const NavList = ({ placeholders, hasUser, navigationItems }) => {
  return (
    <ul className={styles.list}>
      {hasUser
        ? navigationItems.map((item) => <NavItem key={item.key} item={item} />)
        : arrayFill(placeholders).map((_, index) => (
            <NavItemPlaceholder key={index} />
          ))}
    </ul>
  );
};

NavList.propTypes = {
  // xingConnecy
  hasUser: PropTypes.bool,
  navigationItems: PropTypes.array.isRequired,
  // props
  placeholders: PropTypes.number,
};
NavList.defaultProps = {
  navigationItems: [],
};

export { NavList };
